/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

/**
 * Kannada strings — initial machine-assisted draft, pending translation-vendor
 * review (tracked as dependency E8). Missing keys fall back to English.
 */
const CLIENT = 'ಕ್ಲೈಂಟ್';
const SESSIONS = 'ಸೆಷನ್‌ಗಳು';
const THERAPIST = 'ಚಿಕಿತ್ಸಕ';
const STATUS = 'ಸ್ಥಿತಿ';
const PLAN = 'ಯೋಜನೆ';
const MRR = 'MRR';
const TRIAL = 'ಪ್ರಯೋಗ';
const SUBSCRIPTION = 'ಚಂದಾದಾರಿಕೆ';
const ACTION = 'ಕ್ರಿಯೆ';
const NO_SESSIONS = 'ನಿಗದಿಪಡಿಸಿದ ಸೆಷನ್‌ಗಳಿಲ್ಲ.';
const THERAPY_PLANS = 'ಚಿಕಿತ್ಸಾ ಯೋಜನೆಗಳು';
const REPORTS = 'ವರದಿಗಳು';
const HOME_TASKS = 'ಮನೆ ಕಾರ್ಯಗಳು';
const SELECT_A_CLIENT = 'ಕ್ಲೈಂಟ್ ಆಯ್ಕೆಮಾಡಿ';
const TYPE = 'ಪ್ರಕಾರ';
const TIME = 'ಸಮಯ';
const ACTIONS = 'ಕ್ರಿಯೆಗಳು';
const PROGRESS = 'ಪ್ರಗತಿ';
const CITY = 'ನಗರ';
const STATE_LABEL = 'ರಾಜ್ಯ';
const POSTAL_CODE = 'ಪಿನ್ ಕೋಡ್';
const LEGAL_NAME = 'ಕಾನೂನು ಹೆಸರು';
const CONTACT_EMAIL = 'ಸಂಪರ್ಕ ಇಮೇಲ್';
const CONTACT_PHONE = 'ಸಂಪರ್ಕ ಫೋನ್';
const TIMEZONE = 'ಸಮಯ ವಲಯ';
const AMOUNT_RUPEES = 'ಮೊತ್ತ (₹)';
const FULL_NAME = 'ಪೂರ್ಣ ಹೆಸರು';
const EMAIL = 'ಇಮೇಲ್';
const PHONE = 'ಫೋನ್';
const PARENT_FULL_NAME = 'ಪೋಷಕರ ಪೂರ್ಣ ಹೆಸರು';
const PARENT_EMAIL = 'ಪೋಷಕರ ಇಮೇಲ್';
const ACTIVE = 'ಸಕ್ರಿಯ';
const SUSPENDED = 'ಸ್ಥಗಿತಗೊಳಿಸಲಾಗಿದೆ';
const CANCELLED = 'ರದ್ದುಗೊಳಿಸಲಾಗಿದೆ';
const NO_INVOICES = 'ಇನ್‌ವಾಯ್ಸ್‌ಗಳಿಲ್ಲ.';
const DRAFT = 'ಕರಡು';
const PAID = 'ಪಾವತಿಸಲಾಗಿದೆ';
const ADD_LINE_1 = 'ವಿಳಾಸ ಸಾಲು 1';
const COUNTRY_ISO = 'ದೇಶ (ISO)';
const REPORTS_COUNT = '{{count}} ವರದಿಗಳು';
const CURRENT_GOALS = 'ಪ್ರಸ್ತುತ ಗುರಿಗಳು';
const SUB_TARGETS = 'ಉಪ-ಗುರಿಗಳು';
const SAVE_CHANGES = 'ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ';
const FILTER_BY_STATUS = 'ಸ್ಥಿತಿಯ ಮೂಲಕ ಫಿಲ್ಟರ್';
const ALL_STATUS = 'ಎಲ್ಲಾ ಸ್ಥಿತಿಗಳು';

export default {
  common: {
    appName: 'TherapyOS',
    loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ…',
    save: SAVE_CHANGES,
    cancel: 'ರದ್ದುಮಾಡಿ',
    signOut: 'ಲಾಗ್‌ಔಟ್',
    search: 'ಹುಡುಕಿ…',
    notFound: 'ಪುಟ ಕಂಡುಬಂದಿಲ್ಲ',
    backHome: 'ಮುಖಪುಟಕ್ಕೆ ಹಿಂತಿರುಗಿ',
    loadError: 'ಡೇಟಾವನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    saveError: 'ಉಳಿಸಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಫಾರ್ಮ್ ಅನ್ನು ಪರಿಶೀಲಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    view: 'ವೀಕ್ಷಿಸಿ',
    edit: 'ಸಂಪಾದಿಸಿ',
    delete: 'ಅಳಿಸಿ',
  },
  topbar: {
    back: 'ಹಿಂತಿರುಗಿ',
    welcome: 'ಮರಳಿ ಸ್ವಾಗತ',
    welcomeName: 'ಮರಳಿ ಸ್ವಾಗತ, {{name}}',
    addNew: 'ಹೊಸದನ್ನು ಸೇರಿಸಿ',
    notifications: 'ಅಧಿಸೂಚನೆಗಳು',
    noNotifications: 'ಹೊಸ ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ',
    toggleTheme: 'ಡಾರ್ಕ್ ಮೋಡ್ ಬದಲಾಯಿಸಿ',
  },
  status: {
    active: ACTIVE,
    inactive: 'ನಿಷ್ಕ್ರಿಯ',
    discharged: 'ಬಿಡುಗಡೆಯಾಗಿದೆ',
    scheduled: 'ನಿಗದಿಪಡಿಸಲಾಗಿದೆ',
    in_progress: 'ಪ್ರಗತಿಯಲ್ಲಿದೆ',
    completed: 'ಪೂರ್ಣಗೊಂಡಿದೆ',
    cancelled: 'ರದ್ದು',
    no_show: 'ಹಾಜರಾಗಿಲ್ಲ',
  },
  goalStatus: {
    not_started: 'ಪ್ರಾರಂಭವಾಗಿಲ್ಲ',
    emerging: 'ಹೊರಹೊಮ್ಮುತ್ತಿದೆ',
    in_progress: 'ಪ್ರಗತಿಯಲ್ಲಿದೆ',
    achieved: 'ಸಾಧಿಸಲಾಗಿದೆ',
    maintenance: 'ನಿರ್ವಹಣೆ',
    discontinued: 'ಸ್ಥಗಿತಗೊಳಿಸಲಾಗಿದೆ',
  },
  measurementType: {
    frequency: 'ಆವರ್ತನ',
    percent_accuracy: 'ಶೇಕಡಾ ನಿಖರತೆ',
    duration: 'ಅವಧಿ',
    latency: 'ವಿಳಂಬ',
    trials_to_criterion: 'ಮಾನದಂಡದವರೆಗೆ ಪ್ರಯತ್ನಗಳು',
    rating_scale: 'ರೇಟಿಂಗ್ ಮಾಪಕ',
    independence_level: 'ಸ್ವಾತಂತ್ರ್ಯ ಮಟ್ಟ',
    prompt_level: 'ಸೂಚನೆ ಮಟ್ಟ',
    anecdotal: 'ವಿವರಣಾತ್ಮಕ',
  },
  sessionType: {
    individual: 'ವೈಯಕ್ತಿಕ',
    group: 'ಗುಂಪು',
    teletherapy: 'ಟೆಲಿಥೆರಪಿ',
    assessment: 'ಮೌಲ್ಯಮಾಪನ',
    review: 'ಪರಿಶೀಲನೆ',
    supervision: 'ಮೇಲ್ವಿಚಾರಣೆ',
    home_visit: 'ಮನೆ ಭೇಟಿ',
  },
  therapist: {
    dashboard: {
      myClients: 'ನನ್ನ ಕ್ಲೈಂಟ್‌ಗಳು',
      upcoming: 'ಮುಂಬರುವ ಸೆಷನ್‌ಗಳು',
      plans: THERAPY_PLANS,
    },
    clients: {
      title: 'ನನ್ನ ಕ್ಲೈಂಟ್‌ಗಳು',
      count: '{{count}} ಕ್ಲೈಂಟ್‌ಗಳು',
      searchPlaceholder: 'ಕ್ಲೈಂಟ್‌ಗಳನ್ನು ಹುಡುಕಿ…',
      empty: 'ಇನ್ನೂ ಯಾವುದೇ ಕ್ಲೈಂಟ್‌ಗಳನ್ನು ನಿಯೋಜಿಸಿಲ್ಲ.',
    },
    notes: {
      title: 'ಸೆಷನ್ ಟಿಪ್ಪಣಿಗಳು',
      subtitle: 'ನಿಮ್ಮ ಸೆಷನ್‌ಗಳನ್ನು ದಾಖಲಿಸಿ',
      count: 'ದಾಖಲಿಸಲು {{count}} ಸೆಷನ್‌ಗಳು',
      empty: 'ಇನ್ನೂ ದಾಖಲಿಸಲು ಸೆಷನ್‌ಗಳಿಲ್ಲ.',
      open: 'ಟಿಪ್ಪಣಿ ತೆರೆಯಿರಿ',
    },
    schedule: {
      title: 'ವೇಳಾಪಟ್ಟಿ',
      subtitle: 'ನಿಮ್ಮ ಸಾಪ್ತಾಹಿಕ ಸೆಷನ್ ಕ್ಯಾಲೆಂಡರ್',
      add: 'ಹೊಸ ಸೆಷನ್',
      empty: 'ಮುಂಬರುವ ಸೆಷನ್‌ಗಳಿಲ್ಲ.',
      noneDay: 'ಸೆಷನ್‌ಗಳಿಲ್ಲ',
      prevWeek: 'ಹಿಂದಿನ ವಾರ',
      nextWeek: 'ಮುಂದಿನ ವಾರ',
      thisWeek: 'ಈ ವಾರ',
    },
    availability: {
      title: 'ಲಭ್ಯತೆ',
      subtitle: 'ನಿಮ್ಮ ಪುನರಾವರ್ತಿತ ಸಾಪ್ತಾಹಿಕ ಕೆಲಸದ ಸಮಯ',
      save: 'ಲಭ್ಯತೆಯನ್ನು ಉಳಿಸಿ',
      saved: 'ಲಭ್ಯತೆ ಉಳಿಸಲಾಗಿದೆ.',
      saveError: 'ಲಭ್ಯತೆಯನ್ನು ಉಳಿಸಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
      invalid:
        'ನಿಮ್ಮ ಸಮಯ ವಿಂಡೋಗಳನ್ನು ಪರಿಶೀಲಿಸಿ — ಅಂತ್ಯವು ಪ್ರಾರಂಭದ ನಂತರ ಇರಬೇಕು ಮತ್ತು ವಿಂಡೋಗಳು ಪರಸ್ಪರ ಅತಿಕ್ರಮಿಸಬಾರದು.',
      addWindow: 'ವಿಂಡೋ ಸೇರಿಸಿ',
      removeWindow: 'ವಿಂಡೋ ತೆಗೆದುಹಾಕಿ',
      none: 'ಲಭ್ಯವಿಲ್ಲ',
      days: {
        mon: 'ಸೋಮವಾರ',
        tue: 'ಮಂಗಳವಾರ',
        wed: 'ಬುಧವಾರ',
        thu: 'ಗುರುವಾರ',
        fri: 'ಶುಕ್ರವಾರ',
        sat: 'ಶನಿವಾರ',
        sun: 'ಭಾನುವಾರ',
      },
    },
    sessions: {
      title: SESSIONS,
      subtitle: 'ಇಂದಿನ ಸೆಷನ್‌ಗಳು ಮತ್ತು ಜೀವನಚಕ್ರ',
      empty: NO_SESSIONS,
      colClient: CLIENT,
      colType: TYPE,
      colTime: TIME,
      colStatus: STATUS,
      colActions: ACTIONS,
      start: 'ಪ್ರಾರಂಭಿಸಿ',
      complete: 'ಪೂರ್ಣಗೊಳಿಸಿ',
      cancel: 'ರದ್ದು',
      reschedule: 'ಮರುನಿಗದಿ',
      note: 'ಸೆಷನ್ ಟಿಪ್ಪಣಿ',
      rate: 'ರೇಟ್ ಮಾಡಿ',
      rescheduleTitle: 'ಸೆಷನ್ ಮರುನಿಗದಿಪಡಿಸಿ',
      rescheduleSubtitle:
        'ಹೊಸ ಸಮಯವನ್ನು ಆಯ್ಕೆಮಾಡಿ. ಚಿಕಿತ್ಸಕರ ಇತರ ಸೆಷನ್‌ಗಳೊಂದಿಗೆ ಘರ್ಷಣೆಗಳನ್ನು ತಿರಸ್ಕರಿಸಲಾಗುತ್ತದೆ.',
    },
    rate: {
      title: 'ಸೆಷನ್ ರೇಟ್ ಮಾಡಿ',
      subtitle: 'ತೊಡಗಿಸಿಕೊಳ್ಳುವಿಕೆ, ಸಹಕಾರ ಮತ್ತು ಸಂದರ್ಭ',
      engagement: 'ತೊಡಗಿಸಿಕೊಳ್ಳುವಿಕೆ',
      cooperation: 'ಸಹಕಾರ',
      note: 'ಸಂದರ್ಭ ಟಿಪ್ಪಣಿ',
      unrated: 'ರೇಟ್ ಮಾಡಿಲ್ಲ',
      submit: 'ರೇಟಿಂಗ್ ಉಳಿಸಿ',
    },
    note: {
      title: 'ಸೆಷನ್ ಟಿಪ್ಪಣಿ',
      back: 'ಸೆಷನ್‌ಗಳಿಗೆ ಹಿಂತಿರುಗಿ',
      signed: 'ಸಹಿ ಮಾಡಲಾಗಿದೆ',
      trials: 'ಗುರಿ ಪ್ರಯೋಗ ಡೇಟಾ',
      correct: 'ಸರಿ',
      incorrect: 'ತಪ್ಪು',
      prompted: 'ಪ್ರೇರಿಸಲಾಗಿದೆ',
      subjective: 'ವ್ಯಕ್ತಿನಿಷ್ಠ',
      objective: 'ವಸ್ತುನಿಷ್ಠ',
      assessment: 'ಮೌಲ್ಯಮಾಪನ',
      plan: PLAN,
      saveDraft: 'ಕರಡು ಉಳಿಸಿ',
      sign: 'ಸಹಿ ಮಾಡಿ ಲಾಕ್ ಮಾಡಿ',
    },
    plans: {
      title: THERAPY_PLANS,
      subtitle: 'ನಿಮ್ಮ ಕ್ಲೈಂಟ್‌ಗಳಿಗೆ ವೈಯಕ್ತಿಕ ಚಿಕಿತ್ಸಾ ಯೋಜನೆಗಳು',
      count: '{{count}} ಸಕ್ರಿಯ ಯೋಜನೆಗಳು',
      searchPlaceholder: 'ಹೆಸರಿನ ಮೂಲಕ ಯೋಜನೆಗಳನ್ನು ಹುಡುಕಿ…',
      empty: 'ಇನ್ನೂ ಚಿಕಿತ್ಸಾ ಯೋಜನೆಗಳಿಲ್ಲ.',
      progress: 'ಒಟ್ಟಾರೆ ಪ್ರಗತಿ',
      review: 'ಪರಿಶೀಲನೆ',
      reviewDate: 'ಪರಿಶೀಲನೆ ದಿನಾಂಕ',
      currentGoals: CURRENT_GOALS,
      moreGoals: '+{{count}} ಇನ್ನಷ್ಟು',
      viewDetails: 'ವಿವರಗಳನ್ನು ವೀಕ್ಷಿಸಿ',
      updateProgress: 'ಪ್ರಗತಿಯನ್ನು ನವೀಕರಿಸಿ',
      detailsTitle: 'ಚಿಕಿತ್ಸಾ ಯೋಜನೆ ವಿವರಗಳು',
      client: CLIENT,
      program: 'ಕಾರ್ಯಕ್ರಮ',
      startDate: 'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
      goals: 'ಗುರಿಗಳು',
    },
    planForm: {
      newPlan: 'ಹೊಸ ಯೋಜನೆ',
      subtitle: 'ಕ್ಲೈಂಟ್‌ಗಾಗಿ ಚಿಕಿತ್ಸಾ ಯೋಜನೆ ಮತ್ತು ಅದರ ಗುರಿಗಳನ್ನು ರಚಿಸಿ.',
      fromTemplate: 'ಟೆಂಪ್ಲೇಟ್‌ನಿಂದ ಪ್ರಾರಂಭಿಸಿ',
      fromTemplateNone: 'ಟೆಂಪ್ಲೇಟ್ ಇಲ್ಲ — ಖಾಲಿ ಪ್ರಾರಂಭಿಸಿ',
      client: CLIENT,
      selectClient: SELECT_A_CLIENT,
      name: 'ಯೋಜನೆ ಹೆಸರು',
      programType: 'ಕಾರ್ಯಕ್ರಮ ಪ್ರಕಾರ',
      startDate: 'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
      reviewDate: 'ಪರಿಶೀಲನೆ ದಿನಾಂಕ',
      goals: 'ಗುರಿಗಳು',
      addGoal: 'ಗುರಿ ಸೇರಿಸಿ',
      goalN: 'ಗುರಿ {{n}}',
      goalTitle: 'ಗುರಿ',
      domain: 'ಕ್ಷೇತ್ರ',
      selectDomain: 'ಕ್ಷೇತ್ರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
      measurementType: 'ಅಳತೆ ವಿಧಾನ',
      selectMeasurementType: 'ವಿಧಾನವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
      measure: 'ಅಳತೆ ವಿವರ',
      baseline: 'ಬೇಸ್‌ಲೈನ್',
      target: 'ಗುರಿ',
      goalReviewDate: 'ಗುರಿ ಪರಿಶೀಲನೆ ದಿನಾಂಕ',
      approachTags: 'ವಿಧಾನ ಟ್ಯಾಗ್‌ಗಳು',
      approachTagsHint: 'ಅಲ್ಪವಿರಾಮದಿಂದ ಬೇರ್ಪಡಿಸಲಾಗಿದೆ, ಉದಾ. PECS, DTT',
      subTargets: SUB_TARGETS,
      subTargetsHint: '; ನಿಂದ ಬೇರ್ಪಡಿಸಿ — > ನಂತರ ಹಂತಗಳನ್ನು ಸೇರಿಸಿ, ಉದಾ. ಅನುಕರಣೆ > ಮಾದರಿ, ಸೂಚನೆ',
      removeGoal: 'ಗುರಿ ತೆಗೆದುಹಾಕಿ',
      submit: 'ಯೋಜನೆ ರಚಿಸಿ',
    },
    plan: {
      back: 'ಯೋಜನೆಗಳಿಗೆ ಹಿಂತಿರುಗಿ',
      goals: CURRENT_GOALS,
      noGoals: 'ಈ ಯೋಜನೆಗೆ ಇನ್ನೂ ಗುರಿಗಳಿಲ್ಲ.',
      updateStatus: 'ಗುರಿ ಸ್ಥಿತಿಯನ್ನು ನವೀಕರಿಸಿ',
      subTargets: SUB_TARGETS,
      reviewBy: '{{date}} ರೊಳಗೆ ಪರಿಶೀಲನೆ',
      statusNote: 'ಸ್ಥಿತಿ-ಬದಲಾವಣೆ ಟಿಪ್ಪಣಿ (ಐಚ್ಛಿಕ)',
      statusNotePlaceholder: 'ಸ್ಥಿತಿ ಏಕೆ ಬದಲಾಗುತ್ತಿದೆ?',
      history: 'ಸ್ಥಿತಿ ಇತಿಹಾಸ',
      showHistory: 'ಸ್ಥಿತಿ ಇತಿಹಾಸ',
      hideHistory: 'ಇತಿಹಾಸವನ್ನು ಮರೆಮಾಡಿ',
      noHistory: 'ಇನ್ನೂ ಯಾವುದೇ ಸ್ಥಿತಿ ಬದಲಾವಣೆ ದಾಖಲಾಗಿಲ್ಲ.',
      historyEntry: '{{from}} → {{to}}',
      historyInitial: '{{to}} ಗೆ ಹೊಂದಿಸಲಾಗಿದೆ',
      saveAsTemplate: 'ಟೆಂಪ್ಲೇಟ್ ಆಗಿ ಉಳಿಸಿ',
      exportPdf: 'PDF ರಫ್ತು ಮಾಡಿ',
      exporting: 'ರಫ್ತು ಮಾಡಲಾಗುತ್ತಿದೆ…',
      saveTemplateTitle: 'ಟೆಂಪ್ಲೇಟ್ ಆಗಿ ಉಳಿಸಿ',
      saveTemplateSubtitle: 'ಭವಿಷ್ಯದ ಯೋಜನೆಗಳನ್ನು ರಚಿಸುವಾಗ ಈ ಯೋಜನೆಯ ಗುರಿಗಳನ್ನು ಮರುಬಳಸಿ.',
      templateName: 'ಟೆಂಪ್ಲೇಟ್ ಹೆಸರು',
    },
    templates: {
      title: 'ಟೆಂಪ್ಲೇಟ್‌ಗಳು',
      subtitle: 'ನಿಮ್ಮ ಕ್ಲಿನಿಕ್‌ಗಾಗಿ ಮರುಬಳಸಬಹುದಾದ ಯೋಜನೆ ಗುರಿ ಸೆಟ್‌ಗಳು',
      empty: 'ಇನ್ನೂ ಟೆಂಪ್ಲೇಟ್‌ಗಳಿಲ್ಲ. ಗುರಿಗಳನ್ನು ಮರುಬಳಸಲು ಯೋಜನೆಯನ್ನು ಟೆಂಪ್ಲೇಟ್ ಆಗಿ ಉಳಿಸಿ.',
      goalCount: '{{count}} ಗುರಿಗಳು',
      delete: 'ಟೆಂಪ್ಲೇಟ್ ಅಳಿಸಿ',
    },
    collaborators: {
      title: 'ಸಹಯೋಗಿ ಚಿಕಿತ್ಸಕರು',
      none: 'ಇನ್ನೂ ಸಹಯೋಗಿಗಳಿಲ್ಲ.',
      add: 'ಸಹಯೋಗಿಯನ್ನು ಸೇರಿಸಿ…',
      remove: 'ಸಹಯೋಗಿಯನ್ನು ತೆಗೆದುಹಾಕಿ',
    },
    review: {
      title: 'ಕ್ಲಿನಿಕಲ್ ಪರಿಶೀಲನೆಗಳು',
      due: 'ಪರಿಶೀಲನೆ ಬಾಕಿ',
      dueBanner: '{{count}} ಯೋಜನೆಗಳು ಕ್ಲಿನಿಕಲ್ ಪರಿಶೀಲನೆಗೆ ಬಾಕಿ ಇವೆ',
      record: 'ಪರಿಶೀಲನೆಯನ್ನು ದಾಖಲಿಸಿ',
      empty: 'ಇದುವರೆಗೆ ಯಾವುದೇ ಪರಿಶೀಲನೆ ದಾಖಲಾಗಿಲ್ಲ.',
      modalTitle: 'ಕ್ಲಿನಿಕಲ್ ಪರಿಶೀಲನೆಯನ್ನು ದಾಖಲಿಸಿ',
      modalSubtitle: 'ಪರಿಶೀಲನೆ ಫಲಿತಾಂಶವನ್ನು ದಾಖಲಿಸಿ ಮತ್ತು ಮುಂದಿನ ಪರಿಶೀಲನೆ ದಿನಾಂಕವನ್ನು ಹೊಂದಿಸಿ.',
      outcome: 'ಫಲಿತಾಂಶ',
      outcome_continue: 'ಯೋಜನೆ ಮುಂದುವರಿಸಿ',
      outcome_revise: 'ಯೋಜನೆ ಪರಿಷ್ಕರಿಸಿ',
      outcome_discharge: 'ಡಿಸ್ಚಾರ್ಜ್',
      summary: 'ಸಾರಾಂಶ',
      recommendations: 'ಶಿಫಾರಸುಗಳು (ಐಚ್ಛಿಕ)',
      nextDate: 'ಮುಂದಿನ ಪರಿಶೀಲನೆ ದಿನಾಂಕ',
      submit: 'ಪರಿಶೀಲನೆಯನ್ನು ಉಳಿಸಿ',
    },
    homeTasks: {
      link: HOME_TASKS,
      back: 'ನನ್ನ ಕ್ಲೈಂಟ್‌ಗಳಿಗೆ ಹಿಂತಿರುಗಿ',
      title: HOME_TASKS,
      subtitle: 'ಮನೆ-ಕಾರ್ಯಕ್ರಮ ಕಾರ್ಯಗಳನ್ನು ನಿಯೋಜಿಸಿ ಮತ್ತು ಪರಿಶೀಲಿಸಿ',
    },
  },
  parent: {
    selectChild: 'ಮಗು',
    noData: 'ಇನ್ನೂ ಯಾವುದೇ ಡೇಟಾ ದಾಖಲಿಸಿಲ್ಲ',
    dashboard: {
      title: 'ಸ್ವಾಗತ',
      subtitle: 'ನಿಮ್ಮ ಮಕ್ಕಳ ಚಿಕಿತ್ಸೆ ಒಂದು ನೋಟದಲ್ಲಿ',
      empty: 'ಇನ್ನೂ ಯಾವುದೇ ಮಕ್ಕಳನ್ನು ದಾಖಲಿಸಿಲ್ಲ.',
      progress: 'ಒಟ್ಟಾರೆ ಪ್ರಗತಿ',
      viewProgress: 'ಪ್ರಗತಿಯನ್ನು ವೀಕ್ಷಿಸಿ →',
      recentReports: 'ಇತ್ತೀಚಿನ ವರದಿಗಳು',
    },
    achievements: {
      dayStreak: '{{count}} ದಿನಗಳ ಸರಣಿ',
      completed: '{{count}} ಪೂರ್ಣ',
      badge: {
        firstStep: 'ಮೊದಲ ಹೆಜ್ಜೆ',
        threeDay: '3-ದಿನಗಳ ಸರಣಿ',
        weekWarrior: 'ವಾರದ ಯೋಧ',
        fiftyDone: '50 ಪೂರ್ಣ',
      },
    },
    progress: {
      title: PROGRESS,
      subtitle: 'ಕಾಲಾನಂತರ ಗುರಿ ನಿಖರತೆ',
      empty: 'ಇನ್ನೂ ಯಾವುದೇ ಪ್ರಗತಿ ಡೇಟಾ ದಾಖಲಿಸಿಲ್ಲ.',
    },
    sessions: {
      title: SESSIONS,
      subtitle: 'ನಿಮ್ಮ ಮಕ್ಕಳ ಚಿಕಿತ್ಸಾ ವೇಳಾಪಟ್ಟಿ',
      empty: NO_SESSIONS,
      colChild: 'ಮಗು',
      colType: TYPE,
      colTime: TIME,
      colStatus: STATUS,
    },
    billing: {
      title: 'ಬಿಲ್ಲಿಂಗ್',
      subtitle: 'ನಿಮ್ಮ ಇನ್‌ವಾಯ್ಸ್‌ಗಳು ಮತ್ತು ಪಾವತಿಗಳು',
      empty: NO_INVOICES,
      payNow: 'ಈಗ ಪಾವತಿಸಿ',
      payNowTitle: 'ಇನ್‌ವಾಯ್ಸ್ ಪಾವತಿಸಿ',
      payNowSubtitle: 'ಬಾಕಿ ಮೊತ್ತವನ್ನು ಸುರಕ್ಷಿತವಾಗಿ ಪಾವತಿಸಿ (Razorpay).',
      payConfirm: 'ಈಗ ಪಾವತಿಸಿ',
      paying: 'ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ…',
      payError: 'ಪಾವತಿಯನ್ನು ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    },
    reports: {
      title: REPORTS,
      count: REPORTS_COUNT,
      empty: 'ನಿಮ್ಮೊಂದಿಗೆ ಇನ್ನೂ ಯಾವುದೇ ವರದಿಗಳನ್ನು ಹಂಚಿಕೊಂಡಿಲ್ಲ.',
    },
    homeTasks: {
      title: HOME_TASKS,
      subtitle: 'ಇಂದಿನ ಮನೆಯಲ್ಲಿ ಚಿಕಿತ್ಸಾ ಅಭ್ಯಾಸ',
      dailyProgress: 'ದೈನಂದಿನ ಪ್ರಗತಿ',
      completedCount: '{{total}} ರಲ್ಲಿ {{done}} ಇಂದು ಪೂರ್ಣಗೊಂಡಿದೆ',
      completed: 'ಪೂರ್ಣಗೊಂಡಿದೆ ✓',
      dueToday: 'ಇಂದು ಬಾಕಿ',
      markDone: 'ಮುಗಿದಿದೆ ಎಂದು ಗುರುತಿಸಿ',
      empty: 'ಇನ್ನೂ ಯಾವುದೇ ಮನೆ ಕಾರ್ಯಗಳನ್ನು ನಿಯೋಜಿಸಿಲ್ಲ.',
    },
  },
  admin: {
    dashboard: {
      activeClients: 'ಸಕ್ರಿಯ ಕ್ಲೈಂಟ್‌ಗಳು',
      therapists: 'ಚಿಕಿತ್ಸಕರು',
      sessions: SESSIONS,
      sessionsThisMonth: 'ಈ ತಿಂಗಳ ಸೆಷನ್‌ಗಳು',
      avgProgress: 'ಸರಾಸರಿ ಯೋಜನೆ ಪ್ರಗತಿ',
      plans: THERAPY_PLANS,
      distribution: 'ಕ್ಲೈಂಟ್ ವಿತರಣೆ',
      distributionSub: 'ಚಿಕಿತ್ಸಾ ಪ್ರಕಾರದ ಪ್ರಕಾರ',
      sessionsTrend: 'ಸೆಷನ್‌ಗಳು',
      sessionsTrendSub: 'ಕಳೆದ 6 ತಿಂಗಳುಗಳು',
      performance: 'ಚಿಕಿತ್ಸಕ ಕಾರ್ಯಕ್ಷಮತೆ',
      performanceSub: 'ಉನ್ನತ ಪ್ರದರ್ಶಕರು',
      sessionsUnit: '{{count}} ಸೆಷನ್‌ಗಳು',
      upcoming: 'ಮುಂಬರುವ ಸೆಷನ್‌ಗಳು',
      upcomingSub: 'ಇಂದಿನ ವೇಳಾಪಟ್ಟಿ',
      noUpcoming: 'ಮುಂಬರುವ ಸೆಷನ್‌ಗಳಿಲ್ಲ.',
      noData: 'ಇನ್ನೂ ಡೇಟಾ ಇಲ್ಲ.',
      viewAll: 'ಎಲ್ಲವನ್ನೂ ವೀಕ್ಷಿಸಿ',
      activity: 'ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆ',
      activitySub: 'ಇತ್ತೀಚೆಗೆ ಪೂರ್ಣಗೊಂಡ ಸೆಷನ್‌ಗಳು',
      noActivity: 'ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆ ಇಲ್ಲ.',
      activitySession: '{{client}} ಒಂದು ಸೆಷನ್ ಪೂರ್ಣಗೊಳಿಸಿದರು',
    },
    clients: {
      title: 'ಕ್ಲೈಂಟ್ ನಿರ್ವಹಣೆ',
      subtitle: 'ನಿಮ್ಮ ಕ್ಲಿನಿಕ್‌ನಲ್ಲಿ ದಾಖಲಾದ ಮಕ್ಕಳು',
      count: 'ಒಟ್ಟು {{count}} ಕ್ಲೈಂಟ್‌ಗಳು',
      add: 'ಕ್ಲೈಂಟ್ ಸೇರಿಸಿ',
      edit: 'ಕ್ಲೈಂಟ್ ಸಂಪಾದಿಸಿ',
      addSubtitle: 'ಹೊಸ ಕ್ಲೈಂಟ್ ದಾಖಲೆ ರಚಿಸಿ',
      empty: 'ಇನ್ನೂ ಕ್ಲೈಂಟ್‌ಗಳಿಲ್ಲ. ಪ್ರಾರಂಭಿಸಲು ನಿಮ್ಮ ಮೊದಲ ಕ್ಲೈಂಟ್ ಸೇರಿಸಿ.',
      searchPlaceholder: 'ಕ್ಲೈಂಟ್‌ಗಳು, ರೋಗನಿರ್ಣಯ, ಚಿಕಿತ್ಸಕರನ್ನು ಹುಡುಕಿ…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      age: 'ವಯಸ್ಸು {{age}}',
      colName: CLIENT,
      colDiagnosis: 'ರೋಗನಿರ್ಣಯ',
      colTherapist: THERAPIST,
      colSessions: SESSIONS,
      colProgress: PROGRESS,
      colStatus: STATUS,
      colActions: ACTIONS,
      deleteTitle: 'ಕ್ಲೈಂಟ್ ಅಳಿಸಬೇಕೇ?',
      deleteBody: '{{name}} ಮತ್ತು ಅವರ ಎಲ್ಲಾ ದಾಖಲೆಗಳನ್ನು ಶಾಶ್ವತವಾಗಿ ಅಳಿಸಿ. ಇದನ್ನು ರದ್ದುಗೊಳಿಸಲಾಗದು.',
    },
    clientDetail: {
      back: 'ಕ್ಲೈಂಟ್‌ಗಳಿಗೆ ಹಿಂತಿರುಗಿ',
      notFound: 'ಕ್ಲೈಂಟ್ ಕಂಡುಬಂದಿಲ್ಲ.',
      age: 'ವಯಸ್ಸು',
      therapist: THERAPIST,
      guardian: 'ಪೋಷಕ',
      contact: 'ಸಂಪರ್ಕ',
      plans: THERAPY_PLANS,
      noPlans: 'ಇನ್ನೂ ಚಿಕಿತ್ಸಾ ಯೋಜನೆಗಳಿಲ್ಲ.',
      sessions: 'ಇತ್ತೀಚಿನ ಸೆಷನ್‌ಗಳು',
      noSessions: NO_SESSIONS,
      billing: 'ಬಿಲ್ಲಿಂಗ್',
      noInvoices: NO_INVOICES,
    },
    sessions: {
      title: SESSIONS,
      count: '{{count}} ಸೆಷನ್‌ಗಳು',
      empty: NO_SESSIONS,
      searchPlaceholder: 'ಪ್ರಕಾರ ಅಥವಾ ಸ್ಥಳದ ಮೂಲಕ ಹುಡುಕಿ…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      schedule: 'ಸೆಷನ್ ನಿಗದಿಪಡಿಸಿ',
      scheduleSubtitle: 'ಹೊಸ ಚಿಕಿತ್ಸಾ ಸೆಷನ್ ಬುಕ್ ಮಾಡಿ',
      colClient: CLIENT,
      colTherapist: THERAPIST,
      colType: TYPE,
      colTime: TIME,
      colStatus: STATUS,
    },
    users: {
      title: 'ತಂಡದ ಸದಸ್ಯರು',
      count: 'ಒಟ್ಟು {{count}} ಬಳಕೆದಾರರು',
      invite: 'ಬಳಕೆದಾರರನ್ನು ಆಹ್ವಾನಿಸಿ',
      inviteTitle: 'ತಂಡದ ಸದಸ್ಯರನ್ನು ಆಹ್ವಾನಿಸಿ',
      inviteSubtitle: 'ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಿಸಲು ಅವರಿಗೆ ಇಮೇಲ್ ಸಿಗುತ್ತದೆ.',
      empty: 'ಇನ್ನೂ ತಂಡದ ಸದಸ್ಯರಿಲ್ಲ. ಪ್ರಾರಂಭಿಸಲು ನಿಮ್ಮ ಮೊದಲ ಬಳಕೆದಾರರನ್ನು ಆಹ್ವಾನಿಸಿ.',
      enable: 'ಸಕ್ರಿಯಗೊಳಿಸಿ',
      disable: 'ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಿ',
      name: FULL_NAME,
      email: EMAIL,
      role: 'ಪಾತ್ರ',
      inviteError: 'ಆಹ್ವಾನವನ್ನು ಕಳುಹಿಸಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
      col: {
        name: 'ಹೆಸರು',
        email: EMAIL,
        roles: 'ಪಾತ್ರಗಳು',
        status: STATUS,
        lastLogin: 'ಕೊನೆಯ ಲಾಗಿನ್',
      },
      role_CLINIC_ADMIN: 'ಕ್ಲಿನಿಕ್ ಅಡ್ಮಿನ್',
      role_THERAPIST: THERAPIST,
      role_FINANCE: 'ಹಣಕಾಸು',
      status_invited: 'ಆಹ್ವಾನಿಸಲಾಗಿದೆ',
      status_active: ACTIVE,
      status_disabled: 'ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ',
    },
    therapists: {
      title: 'ಚಿಕಿತ್ಸಕ ನಿರ್ವಹಣೆ',
      subtitle: 'ನಿಮ್ಮ ಕ್ಲಿನಿಕ್‌ನ ಕ್ಲಿನಿಕಲ್ ಸಿಬ್ಬಂದಿ',
      registered: '{{count}} ಚಿಕಿತ್ಸಕರು ನೋಂದಾಯಿಸಿದ್ದಾರೆ',
      add: 'ಚಿಕಿತ್ಸಕರನ್ನು ಸೇರಿಸಿ',
      addSubtitle: 'ಹೊಸ ಚಿಕಿತ್ಸಕ ಪ್ರೊಫೈಲ್ ರಚಿಸಿ',
      empty: 'ಇನ್ನೂ ಚಿಕಿತ್ಸಕರಿಲ್ಲ. ಪ್ರಾರಂಭಿಸಲು ನಿಮ್ಮ ಮೊದಲ ಚಿಕಿತ್ಸಕರನ್ನು ಸೇರಿಸಿ.',
      searchPlaceholder: 'ಚಿಕಿತ್ಸಕರನ್ನು ಹುಡುಕಿ…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      clients: 'ಕ್ಲೈಂಟ್‌ಗಳು',
      sessions: SESSIONS,
      rating: 'ರೇಟಿಂಗ್',
      joined: '{{date}} ರಂದು ಸೇರಿದರು',
    },
    finance: {
      title: 'ಹಣಕಾಸು',
      count: '{{count}} ಇನ್‌ವಾಯ್ಸ್‌ಗಳು',
    },
    reports: {
      title: REPORTS,
      count: REPORTS_COUNT,
    },
    invite: {
      title: 'ಪೋಷಕರನ್ನು ಆಹ್ವಾನಿಸಿ',
      subtitle: 'ಈ ಮಗುವಿಗೆ ಪೋಷಕ ಲಾಗಿನ್ ರಚಿಸಿ',
      intro: '{{child}} ರ ಪೋಷಕರಿಗೆ ಪೋಷಕ ಪೋರ್ಟಲ್ ಪ್ರವೇಶಿಸಲು ಆಹ್ವಾನ ಕಳುಹಿಸಿ.',
      parentName: PARENT_FULL_NAME,
      email: PARENT_EMAIL,
      submit: 'ಆಹ್ವಾನ ಕಳುಹಿಸಿ',
      error: 'ಆಹ್ವಾನವನ್ನು ಕಳುಹಿಸಲಾಗಲಿಲ್ಲ. ಇಮೇಲ್ ಈಗಾಗಲೇ ಬಳಕೆಯಲ್ಲಿರಬಹುದು.',
      success: '{{email}} ಗೆ ಆಹ್ವಾನ ಇಮೇಲ್ ಮಾಡಲಾಗಿದೆ.',
      linkLabel: 'ಸಕ್ರಿಯಗೊಳಿಸುವ ಲಿಂಕ್',
      copy: 'ನಕಲಿಸಿ',
      copied: 'ನಕಲಿಸಲಾಗಿದೆ',
      note: 'ನಾವು ಈ ಲಿಂಕ್ ಅನ್ನು ಪೋಷಕರಿಗೆ ಇಮೇಲ್ ಮಾಡಿದ್ದೇವೆ. ನೀವು ಇದನ್ನು ನಕಲಿಸಿ ಹಂಚಿಕೊಳ್ಳಬಹುದು — ಇದು ಅವರಿಗೆ ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಿಸಿ ಸೈನ್ ಇನ್ ಮಾಡಲು ಅನುಮತಿಸುತ್ತದೆ, ಮತ್ತು 7 ದಿನಗಳಲ್ಲಿ ಮುಕ್ತಾಯಗೊಳ್ಳುತ್ತದೆ.',
    },
  },
  form: {
    client: {
      fullName: FULL_NAME,
      age: 'ವಯಸ್ಸು',
      primaryDiagnosis: 'ರೋಗನಿರ್ಣಯ',
      email: EMAIL,
      phone: PHONE,
      assignTherapist: 'ನಿಯೋಜಿತ ಚಿಕಿತ್ಸಕ',
      noTherapist: 'ಚಿಕಿತ್ಸಕರನ್ನು ನಿಯೋಜಿಸಿಲ್ಲ',
      submit: 'ಕ್ಲೈಂಟ್ ಸೇರಿಸಿ',
      guardianName: 'ಪೋಷಕ / ಸಂರಕ್ಷಕ ಹೆಸರು',
      inviteParentNow: 'ಪೋಷಕ ಲಾಗಿನ್ ಅನ್ನೂ ರಚಿಸಿ',
      inviteParentHint:
        'ಪೋಷಕ ಪೋರ್ಟಲ್ ಪ್ರವೇಶಿಸಲು ನಾವು ಪೋಷಕರಿಗೆ ಸಕ್ರಿಯಗೊಳಿಸುವ ಲಿಂಕ್ ಅನ್ನು ಇಮೇಲ್ ಮಾಡುತ್ತೇವೆ.',
      parentName: PARENT_FULL_NAME,
      parentEmail: PARENT_EMAIL,
    },
    therapist: {
      fullName: FULL_NAME,
      email: EMAIL,
      phone: PHONE,
      specialty: 'ವಿಶೇಷತೆ',
      specialisations: 'ವಿಶೇಷೀಕರಣಗಳು',
      specialisationsHint: 'ಅಲ್ಪವಿರಾಮದಿಂದ ಬೇರ್ಪಡಿಸಲಾಗಿದೆ, ಉದಾ. ASD, ಸ್ಪೀಚ್, OT',
      joinedOn: 'ಸೇರಿದ ದಿನಾಂಕ',
      submit: 'ಚಿಕಿತ್ಸಕರನ್ನು ಸೇರಿಸಿ',
    },
    session: {
      client: CLIENT,
      selectClient: SELECT_A_CLIENT,
      therapist: THERAPIST,
      anyTherapist: 'ಯಾವುದೇ ಲಭ್ಯ ಚಿಕಿತ್ಸಕ',
      type: 'ಸೆಷನ್ ಪ್ರಕಾರ',
      typeHint: 'ಉದಾ. ಸ್ಪೀಚ್ ಥೆರಪಿ',
      anyType: 'ಯಾವುದೇ ಪ್ರಕಾರ',
      start: 'ದಿನಾಂಕ & ಸಮಯ',
      submit: 'ಸೆಷನ್ ನಿಗದಿಪಡಿಸಿ',
    },
    reschedule: {
      start: 'ಹೊಸ ದಿನಾಂಕ & ಸಮಯ',
      submit: 'ಮರುನಿಗದಿ',
      conflict: 'ಆ ಸಮಯ ಈ ಚಿಕಿತ್ಸಕರ ಮತ್ತೊಂದು ಸೆಷನ್‌ನೊಂದಿಗೆ ಘರ್ಷಿಸುತ್ತದೆ.',
    },
    invoice: {
      client: CLIENT,
      selectClient: SELECT_A_CLIENT,
      service: 'ಸೇವೆ',
      serviceCustom: 'ಕಸ್ಟಮ್ ಮೊತ್ತ',
      amount: AMOUNT_RUPEES,
      amountHint: 'ಉದಾ. 2500',
      dueDate: 'ಬಾಕಿ ದಿನಾಂಕ',
      notes: 'ಟಿಪ್ಪಣಿಗಳು',
      notesHint: 'ಉದಾ. ಜೂನ್ ಸ್ಪೀಚ್-ಥೆರಪಿ ಸೆಷನ್‌ಗಳು',
      submit: 'ಇನ್‌ವಾಯ್ಸ್ ರಚಿಸಿ',
    },
    payment: {
      balance: 'ಬಾಕಿ ಉಳಿಕೆ: {{amount}}',
      amount: AMOUNT_RUPEES,
      method: 'ಪಾವತಿ ವಿಧಾನ',
      selectMethod: 'ವಿಧಾನ ಆಯ್ಕೆಮಾಡಿ',
      submit: 'ಪಾವತಿ ದಾಖಲಿಸಿ',
    },
    homeTask: {
      title: 'ಕಾರ್ಯ',
      titleHint: 'ಉದಾ. ಆಟದ ಸಮಯದಲ್ಲಿ ಕಣ್ಣಿನ ಸಂಪರ್ಕ ಅಭ್ಯಾಸ ಮಾಡಿ (10 ನಿಮಿ)',
      category: 'ವರ್ಗ',
      selectCategory: 'ವರ್ಗ ಆಯ್ಕೆಮಾಡಿ',
      instructions: 'ಸೂಚನೆಗಳು',
      instructionsHint: 'ಪೋಷಕರಿಗೆ ಐಚ್ಛಿಕ ಮಾರ್ಗದರ್ಶನ',
      submit: 'ಕಾರ್ಯ ನಿಯೋಜಿಸಿ',
    },
  },
  login: {
    welcome: 'ಮರಳಿ ಸ್ವಾಗತ',
    subtitle: 'ನಿಮ್ಮ ಪೋರ್ಟಲ್‌ಗೆ ಸೈನ್ ಇನ್ ಮಾಡಿ',
    selectRole: 'ನಿಮ್ಮ ಪಾತ್ರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    email: 'ಇಮೇಲ್ ವಿಳಾಸ',
    emailPlaceholder: 'ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ',
    password: 'ಪಾಸ್‌ವರ್ಡ್',
    passwordPlaceholder: 'ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ',
    signInTo: '{{portal}} ಗೆ ಸೈನ್ ಇನ್ ಮಾಡಿ',
    selectClinic: 'ನಿಮ್ಮ ಕ್ಲಿನಿಕ್ ಆಯ್ಕೆಮಾಡಿ',
    invalidCredentials: 'ಇಮೇಲ್ ಅಥವಾ ಪಾಸ್‌ವರ್ಡ್ ತಪ್ಪಾಗಿದೆ',
    accountLocked: 'ಖಾತೆ ತಾತ್ಕಾಲಿಕವಾಗಿ ಲಾಕ್ ಆಗಿದೆ. ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    forgotPassword: 'ಪಾಸ್‌ವರ್ಡ್ ಮರೆತಿರಾ?',
    roles: {
      CLINIC_ADMIN: { title: 'ಅಡ್ಮಿನ್ ಪೋರ್ಟಲ್', blurb: 'ಪೂರ್ಣ ಸಿಸ್ಟಮ್ ನಿಯಂತ್ರಣ ಮತ್ತು ನಿರ್ವಹಣೆ' },
      THERAPIST: {
        title: 'ಚಿಕಿತ್ಸಕ ಪೋರ್ಟಲ್',
        blurb: 'ಕ್ಲೈಂಟ್‌ಗಳು ಮತ್ತು ಚಿಕಿತ್ಸಾ ಸೆಷನ್‌ಗಳನ್ನು ನಿರ್ವಹಿಸಿ',
      },
      PARENT: { title: 'ಪೋಷಕ ಪೋರ್ಟಲ್', blurb: 'ನಿಮ್ಮ ಮಗುವಿನ ಪ್ರಗತಿಯನ್ನು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ' },
      FINANCE: { title: 'ಹಣಕಾಸು ಪೋರ್ಟಲ್', blurb: 'ಬಿಲ್ಲಿಂಗ್, ಇನ್‌ವಾಯ್ಸಿಂಗ್ ಮತ್ತು ಪೇರೋಲ್' },
    },
    tagline: 'ಸುರಕ್ಷಿತ • DPDP ಅನುಸರಣೆ • ಎಂಟರ್‌ಪ್ರೈಸ್ ಗ್ರೇಡ್',
  },
  forgot: {
    title: 'ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ಮರುಹೊಂದಿಸಿ',
    subtitle: 'ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ, ನಾವು ನಿಮಗೆ ಮರುಹೊಂದಿಸುವ ಲಿಂಕ್ ಕಳುಹಿಸುತ್ತೇವೆ.',
    submit: 'ಮರುಹೊಂದಿಸುವ ಲಿಂಕ್ ಕಳುಹಿಸಿ',
    sentTitle: 'ನಿಮ್ಮ ಇಮೇಲ್ ಪರಿಶೀಲಿಸಿ',
    sentBody:
      'ಆ ಇಮೇಲ್‌ಗೆ ಖಾತೆ ಇದ್ದರೆ, ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ಮರುಹೊಂದಿಸಲು ನಾವು ಲಿಂಕ್ ಕಳುಹಿಸಿದ್ದೇವೆ. ಲಿಂಕ್ 1 ಗಂಟೆಯಲ್ಲಿ ಮುಕ್ತಾಯಗೊಳ್ಳುತ್ತದೆ.',
    backToLogin: 'ಲಾಗಿನ್‌ಗೆ ಹಿಂತಿರುಗಿ',
  },
  pagination: {
    prev: 'ಹಿಂದಿನ',
    next: 'ಮುಂದಿನ',
    pageOf: 'ಪುಟ {{page}} / {{total}}',
  },
  account: {
    changePassword: {
      title: 'ಪಾಸ್‌ವರ್ಡ್ ಬದಲಾಯಿಸಿ',
      subtitle: 'ನಿಮ್ಮ ಖಾತೆಯ ಪಾಸ್‌ವರ್ಡ್ ನವೀಕರಿಸಿ.',
      current: 'ಪ್ರಸ್ತುತ ಪಾಸ್‌ವರ್ಡ್',
      new: 'ಹೊಸ ಪಾಸ್‌ವರ್ಡ್',
      submit: 'ಪಾಸ್‌ವರ್ಡ್ ನವೀಕರಿಸಿ',
      success: 'ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ನವೀಕರಿಸಲಾಗಿದೆ.',
      error:
        'ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ಬದಲಾಯಿಸಲಾಗಲಿಲ್ಲ. ನಿಮ್ಮ ಪ್ರಸ್ತುತ ಪಾಸ್‌ವರ್ಡ್ ಪರಿಶೀಲಿಸಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    },
  },
  setPassword: {
    title: 'ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಿಸಿ',
    subtitle: 'ನಿಮ್ಮ ಖಾತೆಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲು ಪಾಸ್‌ವರ್ಡ್ ಆಯ್ಕೆಮಾಡಿ.',
    newPassword: 'ಹೊಸ ಪಾಸ್‌ವರ್ಡ್',
    confirmPassword: 'ಪಾಸ್‌ವರ್ಡ್ ದೃಢೀಕರಿಸಿ',
    submit: 'ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಿಸಿ',
    missingToken: 'ಈ ಲಿಂಕ್ ಅಮಾನ್ಯವಾಗಿದೆ ಅಥವಾ ಅದರ ಟೋಕನ್ ಇಲ್ಲ.',
    error:
      'ಈ ಲಿಂಕ್ ಅಮಾನ್ಯವಾಗಿದೆ ಅಥವಾ ಮುಕ್ತಾಯಗೊಂಡಿದೆ. ಇದನ್ನು ಮತ್ತೆ ಕಳುಹಿಸಲು ನಿಮ್ಮ ಕ್ಲಿನಿಕ್‌ಗೆ ಕೇಳಿ.',
    doneTitle: 'ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಿಸಲಾಗಿದೆ',
    doneBody: 'ನಿಮ್ಮ ಖಾತೆ ಸಕ್ರಿಯವಾಗಿದೆ. ನೀವು ಈಗ ಸೈನ್ ಇನ್ ಮಾಡಬಹುದು.',
    goToLogin: 'ಲಾಗಿನ್‌ಗೆ ಹೋಗಿ',
  },
  staffLogin: {
    title: 'ಸಿಬ್ಬಂದಿ ಕನ್ಸೋಲ್',
    subtitle: 'iTech ಆಂತರಿಕ ಪ್ರವೇಶ ಮಾತ್ರ',
    totp: 'ಅಥೆಂಟಿಕೇಟರ್ ಕೋಡ್',
    totpPlaceholder: '6-ಅಂಕಿಯ ಕೋಡ್',
    signIn: 'ಸೈನ್ ಇನ್',
  },
  nav: {
    dashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
    clients: 'ಕ್ಲೈಂಟ್‌ಗಳು',
    therapists: 'ಚಿಕಿತ್ಸಕರು',
    sessions: SESSIONS,
    reports: REPORTS,
    finance: 'ಹಣಕಾಸು',
    analytics: 'ವಿಶ್ಲೇಷಣೆ',
    settings: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    staffUsers: 'ಸಿಬ್ಬಂದಿ ಬಳಕೆದಾರರು',
    users: 'ಬಳಕೆದಾರರು',
    myClients: 'ನನ್ನ ಕ್ಲೈಂಟ್‌ಗಳು',
    schedule: 'ವೇಳಾಪಟ್ಟಿ',
    availability: 'ಲಭ್ಯತೆ',
    sessionNotes: 'ಸೆಷನ್ ಟಿಪ್ಪಣಿಗಳು',
    therapyPlans: THERAPY_PLANS,
    messages: 'ಸಂದೇಶಗಳು',
    progress: PROGRESS,
    homeTasks: HOME_TASKS,
    billing: 'ಬಿಲ್ಲಿಂಗ್',
    invoices: 'ಇನ್‌ವಾಯ್ಸ್‌ಗಳು',
    catalogue: 'ಪಟ್ಟಿ',
    payments: 'ಪಾವತಿಗಳು',
    payroll: 'ಪೇರೋಲ್',
  },
  finance: {
    dashboard: {
      invoiced: 'ಒಟ್ಟು ಇನ್‌ವಾಯ್ಸ್ ಮಾಡಲಾಗಿದೆ',
      collected: 'ಸಂಗ್ರಹಿಸಲಾಗಿದೆ',
      outstanding: 'ಬಾಕಿ',
      invoices: 'ಇನ್‌ವಾಯ್ಸ್‌ಗಳು',
      revenueTrend: 'ಆದಾಯ',
      revenueTrendSub: 'ಸಂಗ್ರಹಿಸಲಾಗಿದೆ, ಕಳೆದ 6 ತಿಂಗಳು',
    },
    invoices: {
      title: 'ಇನ್‌ವಾಯ್ಸ್‌ಗಳು',
      count: '{{count}} ಇನ್‌ವಾಯ್ಸ್‌ಗಳು',
      add: 'ಹೊಸ ಇನ್‌ವಾಯ್ಸ್',
      addSubtitle: 'ಕ್ಲೈಂಟ್‌ಗಾಗಿ ಹೊಸ ಇನ್‌ವಾಯ್ಸ್ ರಚಿಸಿ',
      empty: NO_INVOICES,
      searchPlaceholder: 'ಇನ್‌ವಾಯ್ಸ್ ಸಂಖ್ಯೆ ಅಥವಾ ಟಿಪ್ಪಣಿಗಳ ಮೂಲಕ ಹುಡುಕಿ…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      recordPayment: 'ಪಾವತಿ ದಾಖಲಿಸಿ',
      recordPaymentSubtitle: 'ಈ ಇನ್‌ವಾಯ್ಸ್‌ಗೆ ಪಾವತಿ ದಾಖಲಿಸಿ',
      col: {
        number: 'ಇನ್‌ವಾಯ್ಸ್',
        client: CLIENT,
        amount: 'ಮೊತ್ತ',
        balance: 'ಉಳಿಕೆ',
        due: 'ಬಾಕಿ',
        status: STATUS,
      },
    },
    reports: {
      title: REPORTS,
      count: REPORTS_COUNT,
    },
    catalogue: {
      title: 'ಸೇವಾ ಪಟ್ಟಿ',
      count: '{{count}} ಸೇವೆಗಳು',
      add: 'ಸೇವೆ ಸೇರಿಸಿ',
      addTitle: 'ಸೇವೆ ಸೇರಿಸಿ',
      editTitle: 'ಸೇವೆ ತಿದ್ದಿ',
      subtitle: 'ಪೂರ್ವನಿಯೋಜಿತ ಬೆಲೆಯ ಸೇವೆ; ಇನ್‌ವಾಯ್ಸ್‌ಗಳು ಇದರಿಂದ ಬೆಲೆ ಪಡೆಯುತ್ತವೆ.',
      name: 'ಸೇವೆಯ ಹೆಸರು',
      price: 'ಪೂರ್ವನಿಯೋಜಿತ ಬೆಲೆ (₹)',
      priceHint: 'ಉದಾ. 2500',
      description: 'ವಿವರಣೆ (ಐಚ್ಛಿಕ)',
      save: 'ಸೇವೆ ಉಳಿಸಿ',
      empty: 'ಇನ್ನೂ ಸೇವೆಗಳಿಲ್ಲ — ಮೊದಲ ಶುಲ್ಕ ಪಟ್ಟಿ ಐಟಂ ಸೇರಿಸಿ.',
      edit: 'ಸೇವೆ ತಿದ್ದಿ',
      delete: 'ಸೇವೆ ತೆಗೆದುಹಾಕಿ',
      inactive: 'ನಿಷ್ಕ್ರಿಯ',
    },
  },
  reports: {
    recent: 'ಇತ್ತೀಚಿನ ವರದಿಗಳು',
    generate: 'ವರದಿ ರಚಿಸಿ',
    generateError: 'ಆ ವರದಿಯನ್ನು ಪ್ರಾರಂಭಿಸಲಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
    loading: 'ವರದಿಗಳು ಲೋಡ್ ಆಗುತ್ತಿವೆ…',
    error: 'ವರದಿಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗಲಿಲ್ಲ.',
    empty: 'ಇನ್ನೂ ವರದಿಗಳಿಲ್ಲ — ಮೇಲೆ ಒಂದನ್ನು ರಚಿಸಿ.',
    download: 'ಡೌನ್‌ಲೋಡ್',
    field: {
      type: 'ವರದಿ ಪ್ರಕಾರ',
      client: CLIENT,
      selectClient: SELECT_A_CLIENT,
      from: 'ಇಂದ',
      to: 'ವರೆಗೆ',
    },
    type: {
      client_progress: 'ಕ್ಲೈಂಟ್ ಪ್ರಗತಿ',
      attendance: 'ಹಾಜರಾತಿ',
      revenue: 'ಆದಾಯ',
    },
    status: {
      queued: 'ಸಾಲಿನಲ್ಲಿದೆ',
      running: 'ರಚಿಸುತ್ತಿದೆ…',
      succeeded: 'ಸಿದ್ಧ',
      failed: 'ವಿಫಲವಾಗಿದೆ',
    },
    col: {
      report: 'ವರದಿ',
      status: STATUS,
      created: 'ರಚಿಸಲಾಗಿದೆ',
      action: '',
    },
  },
  invoiceStatus: {
    draft: DRAFT,
    sent: 'ಕಳುಹಿಸಲಾಗಿದೆ',
    partial: 'ಭಾಗಶಃ',
    paid: PAID,
    overdue: 'ಅವಧಿ ಮೀರಿದೆ',
    void: 'ರದ್ದು',
  },
  payroll: {
    title: 'ಪೇರೋಲ್',
    count: '{{count}} ರನ್‌ಗಳು',
    add: 'ಹೊಸ ಪೇರೋಲ್ ರನ್',
    addSubtitle: 'ಪಾವತಿ ಅವಧಿಗೆ ಪೇರೋಲ್ ರನ್ ರಚಿಸಿ',
    empty: 'ಇನ್ನೂ ಪೇರೋಲ್ ರನ್‌ಗಳಿಲ್ಲ.',
    colPeriod: 'ಅವಧಿ',
    colTotal: 'ಒಟ್ಟು',
    colStatus: STATUS,
    form: {
      period: 'ಪಾವತಿ ಅವಧಿ',
      periodHint: 'ಉದಾ. ಜೂನ್ 2026',
      start: 'ಅವಧಿ ಪ್ರಾರಂಭ',
      end: 'ಅವಧಿ ಅಂತ್ಯ',
      notes: 'ಟಿಪ್ಪಣಿಗಳು',
      submit: 'ರನ್ ರಚಿಸಿ',
      therapist: THERAPIST,
      selectTherapist: 'ಚಿಕಿತ್ಸಕರನ್ನು ಆಯ್ಕೆಮಾಡಿ',
      gross: 'ಒಟ್ಟು ವೇತನ (₹)',
      sessions: SESSIONS,
      addSubmit: 'ಪೇಸ್ಲಿಪ್ ಸೇರಿಸಿ',
    },
    detail: {
      title: 'ಪೇರೋಲ್ ರನ್',
      total: 'ಒಟ್ಟು: {{amount}}',
      addPayslip: 'ಪೇಸ್ಲಿಪ್ ಸೇರಿಸಿ',
      addSubtitle: 'ಈ ರನ್‌ಗೆ ಚಿಕಿತ್ಸಕ ಪೇಸ್ಲಿಪ್ ಸೇರಿಸಿ',
      process: 'ಪ್ರಕ್ರಿಯೆ',
      empty: 'ಇನ್ನೂ ಪೇಸ್ಲಿಪ್‌ಗಳಿಲ್ಲ.',
      colTherapist: THERAPIST,
      colSessions: SESSIONS,
      colGross: 'ಒಟ್ಟು',
    },
  },
  payrollStatus: {
    draft: DRAFT,
    processed: 'ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗಿದೆ',
    paid: PAID,
  },
  paymentMethod: {
    cash: 'ನಗದು',
    card: 'ಕಾರ್ಡ್',
    upi: 'UPI',
    bank_transfer: 'ಬ್ಯಾಂಕ್ ವರ್ಗಾವಣೆ',
    razorpay: 'Razorpay',
  },
  home: {
    assign: 'ಕಾರ್ಯ ನಿಯೋಜಿಸಿ',
    assignSubtitle: 'ಈ ಕ್ಲೈಂಟ್‌ಗಾಗಿ ಮನೆ-ಕಾರ್ಯಕ್ರಮ ಕಾರ್ಯ ಸೇರಿಸಿ',
  },
  homeCategory: {
    social: 'ಸಾಮಾಜಿಕ',
    sensory: 'ಸಂವೇದನಾ',
    cognitive: 'ಅರಿವಿನ',
    communication: 'ಸಂವಹನ',
    motor: 'ಮೋಟಾರ್',
    other: 'ಇತರ',
  },
  analytics: {
    title: 'ವಿಶ್ಲೇಷಣೆ',
    subtitle: 'ಕ್ಲಿನಿಕ್ ಕಾರ್ಯಕ್ಷಮತೆ ಒಂದು ನೋಟದಲ್ಲಿ',
    financeSubtitle: 'ಆದಾಯ ಮತ್ತು ಸಂಗ್ರಹಣೆ ಒಂದು ನೋಟದಲ್ಲಿ',
    totalClients: 'ಒಟ್ಟು ಕ್ಲೈಂಟ್‌ಗಳು',
    completedSessions: 'ಪೂರ್ಣಗೊಂಡ ಸೆಷನ್‌ಗಳು',
    sessionsByStatus: 'ಸ್ಥಿತಿಯ ಪ್ರಕಾರ ಸೆಷನ್‌ಗಳು',
    clientsByStatus: 'ಸ್ಥಿತಿಯ ಪ್ರಕಾರ ಕ್ಲೈಂಟ್‌ಗಳು',
    invoicesByStatus: 'ಸ್ಥಿತಿಯ ಪ್ರಕಾರ ಇನ್‌ವಾಯ್ಸ್‌ಗಳು',
    collections: 'ಇನ್‌ವಾಯ್ಸ್ vs ಸಂಗ್ರಹಣೆ (₹)',
  },
  settings: {
    title: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    subtitle: 'ನಿಮ್ಮ ಕ್ಲಿನಿಕ್ ಪ್ರೊಫೈಲ್ ನಿರ್ವಹಿಸಿ',
    name: 'ಕ್ಲಿನಿಕ್ ಹೆಸರು',
    legalName: LEGAL_NAME,
    email: CONTACT_EMAIL,
    phone: CONTACT_PHONE,
    timezone: TIMEZONE,
    gstin: 'GSTIN',
    address: 'ವಿಳಾಸ',
    line1: ADD_LINE_1,
    line2: 'ವಿಳಾಸ ಸಾಲು 2',
    city: CITY,
    state: STATE_LABEL,
    postalCode: POSTAL_CODE,
    country: COUNTRY_ISO,
    save: SAVE_CHANGES,
    saved: 'ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಉಳಿಸಲಾಗಿದೆ.',
    tabs: { profile: 'ಪ್ರೊಫೈಲ್', notifications: 'ಅಧಿಸೂಚನೆಗಳು', security: 'ಭದ್ರತೆ' },
    notifications: {
      sessionReminders: 'ಅವಧಿ ಜ್ಞಾಪನೆಗಳು',
      sessionRemindersDesc: 'ಮುಂಬರುವ ಅವಧಿಗಳ ಮೊದಲು ಇಮೇಲ್ ಜ್ಞಾಪನೆಗಳು.',
      paymentAlerts: 'ಪಾವತಿ ಎಚ್ಚರಿಕೆಗಳು',
      paymentAlertsDesc: 'ಸರಕುಪಟ್ಟಿಗಳು ಪಾವತಿಯಾದಾಗ ಅಥವಾ ಬಾಕಿ ಇದ್ದಾಗ ತಿಳಿಸಿ.',
      progressReports: 'ಪ್ರಗತಿ ವರದಿಗಳು',
      progressReportsDesc: 'ಪ್ರಗತಿ ವರದಿ ಸಿದ್ಧವಾದಾಗ ತಿಳಿಸಿ.',
      systemUpdates: 'ಸಿಸ್ಟಂ ನವೀಕರಣಗಳು',
      systemUpdatesDesc: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಮತ್ತು ನಿರ್ವಹಣೆ ಪ್ರಕಟಣೆಗಳು.',
    },
    security: {
      subtitle: 'ನಿಮ್ಮ ಖಾತೆಯ ಪಾಸ್‌ವರ್ಡ್ ಬದಲಾಯಿಸಿ. ಈ ಸಾಧನದಲ್ಲಿ ನೀವು ಸೈನ್ ಇನ್ ಆಗಿಯೇ ಇರುತ್ತೀರಿ.',
    },
  },
  messages: {
    title: 'ಸಂದೇಶಗಳು',
    new: 'ಹೊಸ ಸಂದೇಶ',
    newSubtitle: 'ಸಂಪರ್ಕದೊಂದಿಗೆ ಸಂಭಾಷಣೆ ಪ್ರಾರಂಭಿಸಿ',
    empty: 'ಇನ್ನೂ ಸಂದೇಶಗಳಿಲ್ಲ.',
    conversation: 'ಸಂಭಾಷಣೆ',
    composer: 'ಸಂದೇಶ ಟೈಪ್ ಮಾಡಿ…',
    noContacts: 'ಸಂದೇಶ ಕಳುಹಿಸಲು ಸಂಪರ್ಕಗಳಿಲ್ಲ.',
    selectContact: 'ಸಂಪರ್ಕ ಆಯ್ಕೆಮಾಡಿ',
    startChat: 'ಚಾಟ್ ಪ್ರಾರಂಭಿಸಿ',
    pickConversation: 'ಚಾಟ್ ಪ್ರಾರಂಭಿಸಲು ಸಂಭಾಷಣೆ ಆಯ್ಕೆಮಾಡಿ',
  },
  sa: {
    dashboard: {
      title: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಅವಲೋಕನ',
      subtitle: 'TherapyOS ನಲ್ಲಿರುವ ಎಲ್ಲಾ ಕ್ಲಿನಿಕ್‌ಗಳು ಒಂದು ನೋಟದಲ್ಲಿ',
      empty: 'ಇನ್ನೂ ಡೇಟಾ ಇಲ್ಲ.',
      totalClinics: 'ಒಟ್ಟು ಕ್ಲಿನಿಕ್‌ಗಳು',
      activeClinics: 'ಸಕ್ರಿಯ ಕ್ಲಿನಿಕ್‌ಗಳು',
      mrr: 'ಮಾಸಿಕ ಪುನರಾವರ್ತಿತ ಆದಾಯ',
      health: 'ಆರೋಗ್ಯ (G / A / R)',
      healthHint: 'ಹಸಿರು / ಅಂಬರ್ / ಕೆಂಪು',
      topBySessions: 'ಸೆಷನ್‌ಗಳ ಪ್ರಕಾರ ಉನ್ನತ ಕ್ಲಿನಿಕ್‌ಗಳು',
      topByRevenue: 'ಆದಾಯದ ಪ್ರಕಾರ ಉನ್ನತ ಕ್ಲಿನಿಕ್‌ಗಳು (₹)',
    },
    clinics: {
      title: 'ಕ್ಲಿನಿಕ್‌ಗಳು',
      count: '{{count}} ಕ್ಲಿನಿಕ್‌ಗಳು',
      add: 'ಹೊಸ ಕ್ಲಿನಿಕ್',
      empty: 'ಇನ್ನೂ ಯಾವುದೇ ಕ್ಲಿನಿಕ್‌ಗಳನ್ನು ಆನ್‌ಬೋರ್ಡ್ ಮಾಡಿಲ್ಲ.',
      searchPlaceholder: 'ಹೆಸರು, ಯೋಜನೆ ಅಥವಾ ಸ್ಥಿತಿಯ ಮೂಲಕ ಹುಡುಕಿ…',
      colName: CLIENT,
      colStatus: STATUS,
      colPlan: PLAN,
      colMrr: MRR,
      colTherapists: THERAPIST,
      colActiveClients: 'ಸಕ್ರಿಯ ಕ್ಲೈಂಟ್‌ಗಳು',
    },
    subscriptions: {
      title: 'ಚಂದಾದಾರಿಕೆಗಳು',
      count: '{{count}} ಕ್ಲಿನಿಕ್‌ಗಳು',
      empty: 'ಇನ್ನೂ ಚಂದಾದಾರಿಕೆಗಳಿಲ್ಲ.',
      col: {
        clinic: 'ಕ್ಲಿನಿಕ್',
        plan: PLAN,
        status: STATUS,
        mrr: MRR,
        renews: 'ನವೀಕರಣ / ಪ್ರಯೋಗ ಅಂತ್ಯ',
        actions: '',
      },
      markPaid: 'ಪಾವತಿಸಲಾಗಿದೆ ಎಂದು ಗುರುತಿಸಿ',
      status: {
        active: ACTIVE,
        trialing: TRIAL,
        past_due: 'ಬಾಕಿ',
        suspended: SUSPENDED,
        cancelled: 'ರದ್ದು',
        none: 'ಯೋಜನೆ ಇಲ್ಲ',
      },
    },
    usage: {
      title: 'ಬಳಕೆ & ಆರೋಗ್ಯ',
      healthSummary: '{{green}} ಹಸಿರು · {{amber}} ಅಂಬರ್ · {{red}} ಕೆಂಪು',
      empty: 'ಇನ್ನೂ ಬಳಕೆ ಡೇಟಾ ಇಲ್ಲ.',
      col: {
        clinic: 'ಕ್ಲಿನಿಕ್',
        health: 'ಆರೋಗ್ಯ',
        sessions: 'ಸೆಷನ್‌ಗಳು (30ದಿ)',
        whatsapp: 'ವಾಟ್ಸಾಪ್',
        sms: 'SMS',
        pdfs: 'PDFಗಳು',
        storage: 'ಸಂಗ್ರಹಣೆ',
        users: 'ಸಕ್ರಿಯ ಬಳಕೆದಾರರು',
      },
      health: {
        green: 'ಆರೋಗ್ಯಕರ',
        amber: 'ಅಪಾಯದಲ್ಲಿ',
        red: 'ಗಂಭೀರ',
        unknown: 'ಅಜ್ಞಾತ',
      },
    },
    staff: {
      title: 'ಸಿಬ್ಬಂದಿ ಬಳಕೆದಾರರು',
      count: '{{count}} ಸಿಬ್ಬಂದಿ ಖಾತೆಗಳು',
      add: 'ಸಿಬ್ಬಂದಿ ಬಳಕೆದಾರ ಸೇರಿಸಿ',
      empty: 'ಇನ್ನೂ ಸಿಬ್ಬಂದಿ ಖಾತೆಗಳಿಲ್ಲ.',
      active: ACTIVE,
      inactive: 'ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ',
      enable: 'ಸಕ್ರಿಯಗೊಳಿಸಿ',
      disable: 'ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಿ',
      col: {
        member: 'ಸದಸ್ಯ',
        role: 'ಪಾತ್ರ',
        status: STATUS,
        lastLogin: 'ಕೊನೆಯ ಲಾಗಿನ್',
        actions: '',
      },
      role: {
        PLATFORM_OWNER: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಮಾಲೀಕ',
        CUSTOMER_SUCCESS: 'ಗ್ರಾಹಕ ಯಶಸ್ಸು',
        SUPPORT: 'ಬೆಂಬಲ',
        READONLY_AUDITOR: 'ಓದಲು-ಮಾತ್ರ ಲೆಕ್ಕಪರಿಶೋಧಕ',
      },
      form: {
        fullName: FULL_NAME,
        email: EMAIL,
        role: 'ಪಾತ್ರ',
        submit: 'ಖಾತೆ ರಚಿಸಿ',
        error: 'ಖಾತೆ ರಚಿಸಲಾಗಲಿಲ್ಲ (ಇಮೇಲ್ ಬಳಕೆಯಲ್ಲಿರಬಹುದು).',
      },
      created: {
        title: 'ಖಾತೆ ರಚಿಸಲಾಗಿದೆ',
        intro: '{{email}} ನೊಂದಿಗೆ ಈ ರುಜುವಾತುಗಳನ್ನು ಸುರಕ್ಷಿತವಾಗಿ ಹಂಚಿಕೊಳ್ಳಿ.',
        copy: 'ನಕಲಿಸಿ',
        warning: 'ಒಮ್ಮೆ ಮಾತ್ರ ತೋರಿಸಲಾಗುತ್ತದೆ — ಸದಸ್ಯರು ಮೊದಲ ಲಾಗಿನ್‌ನಲ್ಲಿ ಈ ಪಾಸ್‌ವರ್ಡ್ ಬದಲಾಯಿಸಬೇಕು.',
        done: 'ಮುಗಿದಿದೆ',
      },
    },
    clinicStatus: {
      active: ACTIVE,
      trial: TRIAL,
      trialing: TRIAL,
      suspended: SUSPENDED,
      cancelled: CANCELLED,
      past_due: 'ಬಾಕಿ',
    },
    detail: {
      back: 'ಕ್ಲಿನಿಕ್‌ಗಳಿಗೆ ಹಿಂತಿರುಗಿ',
      notFound: 'ಕ್ಲಿನಿಕ್ ಕಂಡುಬಂದಿಲ್ಲ.',
      overview: 'ಅವಲೋಕನ',
      legalName: LEGAL_NAME,
      contactEmail: CONTACT_EMAIL,
      contactPhone: CONTACT_PHONE,
      timezone: TIMEZONE,
      createdAt: 'ಆನ್‌ಬೋರ್ಡ್ ಮಾಡಲಾಗಿದೆ',
      subscription: SUBSCRIPTION,
      noSubscription: 'ಸಕ್ರಿಯ ಚಂದಾದಾರಿಕೆ ಇಲ್ಲ.',
      plan: PLAN,
      subStatus: STATUS,
      mrr: MRR,
      periodEnd: 'ನವೀಕರಣ',
      therapists: THERAPIST,
      activeClients: 'ಸಕ್ರಿಯ ಕ್ಲೈಂಟ್‌ಗಳು',
      sessions: SESSIONS,
      invoiced: 'ಇನ್‌ವಾಯ್ಸ್ ಮಾಡಲಾಗಿದೆ',
      recentAudit: 'ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆ',
      noAudit: 'ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆ ಇಲ್ಲ.',
    },
    audit: {
      title: 'ಲೆಕ್ಕಪರಿಶೋಧನಾ ಲಾಗ್',
      subtitle: 'ಎಲ್ಲಾ ಕ್ಲಿನಿಕ್‌ಗಳಲ್ಲಿ ಪ್ಲಾಟ್‌ಫಾರ್ಮ್-ವ್ಯಾಪಕ ಚಟುವಟಿಕೆ',
      empty: 'ಈ ಫಿಲ್ಟರ್‌ಗಳಿಗೆ ಯಾವುದೇ ಲೆಕ್ಕಪರಿಶೋಧನಾ ನಮೂದುಗಳು ಹೊಂದಿಕೆಯಾಗುವುದಿಲ್ಲ.',
      allClinics: 'ಎಲ್ಲಾ ಕ್ಲಿನಿಕ್‌ಗಳು',
      filterClinic: 'ಕ್ಲಿನಿಕ್ ಮೂಲಕ ಫಿಲ್ಟರ್',
      filterAction: 'ಕ್ರಿಯೆಯ ಮೂಲಕ ಫಿಲ್ಟರ್…',
      filterFrom: 'ದಿನಾಂಕದಿಂದ',
      filterTo: 'ದಿನಾಂಕದವರೆಗೆ',
      colTime: TIME,
      colClinic: 'ಕ್ಲಿನಿಕ್',
      colActor: 'ನಟ',
      colAction: ACTION,
      colEntity: 'ಘಟಕ',
    },
    settings: {
      title: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
      subtitle: 'ವೈಶಿಷ್ಟ್ಯ ಫ್ಲ್ಯಾಗ್‌ಗಳು ಮತ್ತು ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಕಾನ್ಫಿಗರೇಶನ್',
      flags: 'ವೈಶಿಷ್ಟ್ಯ ಫ್ಲ್ಯಾಗ್‌ಗಳು',
      empty: 'ಇನ್ನೂ ವೈಶಿಷ್ಟ್ಯ ಫ್ಲ್ಯಾಗ್‌ಗಳಿಲ್ಲ. ಕೆಳಗೆ ಒಂದನ್ನು ಸೇರಿಸಿ.',
      enabled: 'ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ',
      disabled: 'ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ',
      enable: 'ಸಕ್ರಿಯಗೊಳಿಸಿ',
      disable: 'ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಿ',
      addKey: 'ವೈಶಿಷ್ಟ್ಯ ಫ್ಲ್ಯಾಗ್ ಸೇರಿಸಿ',
      addPlaceholder: 'ಉದಾ. parent_app_v2',
      add: 'ಸೇರಿಸಿ',
      col: {
        key: 'ಫ್ಲ್ಯಾಗ್',
        state: 'ಸ್ಥಿತಿ',
        updated: 'ನವೀಕರಿಸಲಾಗಿದೆ',
      },
    },
    wizard: {
      title: 'ಕ್ಲಿನಿಕ್ ಆನ್‌ಬೋರ್ಡ್ ಮಾಡಿ',
      subtitle: 'ಕ್ಲಿನಿಕ್, ಅದರ ಮೊದಲ ಅಡ್ಮಿನ್ ಮತ್ತು ಸಕ್ರಿಯ ಚಂದಾದಾರಿಕೆ ರಚಿಸಿ',
      stepOf: '{{total}} ರಲ್ಲಿ ಹಂತ {{step}}',
      clinicName: 'ಕ್ಲಿನಿಕ್ ಹೆಸರು',
      legalName: LEGAL_NAME,
      contactEmail: CONTACT_EMAIL,
      contactPhone: CONTACT_PHONE,
      line1: ADD_LINE_1,
      city: CITY,
      state: STATE_LABEL,
      postalCode: POSTAL_CODE,
      country: 'ದೇಶ (ISO 3166-1 alpha-2)',
      adminName: 'ಮೊದಲ ಅಡ್ಮಿನ್ ಹೆಸರು',
      adminEmail: 'ಮೊದಲ ಅಡ್ಮಿನ್ ಇಮೇಲ್',
      planSlug: PLAN,
      trialDays: 'ಪ್ರಯೋಗ ದಿನಗಳು (ಐಚ್ಛಿಕ)',
      back: 'ಹಿಂದೆ',
      next: 'ಮುಂದೆ',
      submit: 'ಕ್ಲಿನಿಕ್ ಆನ್‌ಬೋರ್ಡ್ ಮಾಡಿ',
    },
  },
  banner: {
    impersonation:
      '⚠ ನೀವು {{clinic}} ಅನ್ನು {{staff}} ಆಗಿ ವೀಕ್ಷಿಸುತ್ತಿದ್ದೀರಿ — ಎಲ್ಲಾ ಕ್ರಿಯೆಗಳು ಲೆಕ್ಕಪರಿಶೋಧನೆ-ಲಾಗ್ ಆಗುತ್ತವೆ. ಸೆಷನ್ {{remaining}} ರಲ್ಲಿ ಮುಕ್ತಾಯಗೊಳ್ಳುತ್ತದೆ.',
    readOnly: 'ಖಾತೆ ಓದಲು-ಮಾತ್ರ ಮೋಡ್‌ನಲ್ಲಿದೆ — ಮುಂದುವರಿಸಲು ನಿಮ್ಮ ಚಂದಾದಾರಿಕೆ ನವೀಕರಿಸಿ.',
  },
} as const;
